import { Organization } from './';

// Org + Awards
import { AWARDS } from '../awards/list';

// Award names for schema markup: trimmed and without duplicates.
export const AwardNames = [
  ...new Set(
    AWARDS.flatMap((group) =>
      group.awards.map((item) => item.name.replace(/\s+/g, ' ').trim())
    )
  ),
];

// A copy of the Organization, so importing this never alters the shared one.
export const Awards = { ...Organization, award: AwardNames };
